import React from "react";

import styled from "styled-components";
import { colorSelector } from "../../utils/ColorSelector";
import { BaseChequeredCard } from "../BaseChequeredCard";
import { Link } from "../Link";
import { Text } from "../Text";

interface Props {
  title: string;
  content: string;
  link?: string;
  variant: "chequered" | "solid";
}

const StyledText = styled(Text)`
  & > a {
    text-decoration: none;
    color: ${colorSelector("accent")};
  }
  flex: 1 0 auto;
`;

export const ChequeredCard: React.FC<Props> = ({ title, content, link, variant }) => (
  <BaseChequeredCard title={title} variant={variant}>
    <StyledText dangerouslySetInnerHTML={{ __html: content }} />
    {link && (
      <Link
        data-testid="ChequeredCard__link"
        gaTrack={{
          action: "Clicked",
          label: title,
        }}
        href={link}
        target="_blank"
      >
        view details
      </Link>
    )}
  </BaseChequeredCard>
);
